
import React, { createContext, useContext, useState, ReactNode } from 'react';
import { ChurchPresence } from '../../data/types/region-types';

interface LegendFilterContextType {
  activeFilter: ChurchPresence | null;
  toggleFilter: (presence: ChurchPresence) => void;
}

const LegendFilterContext = createContext<LegendFilterContextType | undefined>(undefined);

export const LegendFilterProvider = ({ children }: { children: ReactNode }) => {
  // Initialize with "Low" filter active by default
  const [activeFilter, setActiveFilter] = useState<ChurchPresence>('Low');

  const toggleFilter = (presence: ChurchPresence) => {
    setActiveFilter(presence);
    console.log("Legend filter set to:", presence);
  };

  return (
    <LegendFilterContext.Provider value={{ activeFilter, toggleFilter }}>
      {children}
    </LegendFilterContext.Provider>
  );
};

export const useLegendFilter = () => {
  const context = useContext(LegendFilterContext);
  if (context === undefined) {
    throw new Error('useLegendFilter must be used within a LegendFilterProvider');
  }
  return context;
};
